<!--  -->
<template>
  <div id="global-title" :style="{borderBottom:border ? '1px solid #e8e8e8':'none'}">
    <div class="content-view">{{ title }}</div>
    <div class="operation-view">
      <slot name="operate"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "global-title",
  data() {
    return {};
  },
  props: {
    title: String,
    border: Boolean,
  },
};
</script>
<style lang='scss' scoped>
#global-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 55px;
  background-color: #fff;
  .content-view {
    font-size: 16px;
    font-weight: 600;
    color: #000;
    text-indent: 24px;
  }

  .operation-view {
    margin-right: 25px;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/common/title.vue